export interface Review {
  author: string
  rating: number
  text: string
  date: string
}

export interface BusinessImage {
  url: string
  alt: string
  caption?: string
}

export interface MenuItem {
  name: string
  description: string
  price: string
  image: string
}

export interface Business {
  slug: string
  name: string
  description: string
  longDescription?: string
  status: 'active' | 'coming-soon'
  image: string
  images?: BusinessImage[]
  gradient: string
  location: string
  address: string
  category: string
  services?: string[]
  features?: string[]
  hours?: string
  contact?: string
  contactPerson?: string
  contactNumber?: string
  email?: string
  website?: string
  instagram?: string
  facebook?: string
  lineId?: string
  capacity?: string
  reviews?: Review[]
  gallery?: BusinessImage[]
  menuItems?: MenuItem[]
  movies?: string[]
  tvcs?: string[]
  registrations?: string[]
  managingDirector?: string
  establishedYear?: string
}

export const businesses: Business[] = [
  {
    slug: 'j-square-filming-thailand',
    name: 'J Square Filming Thailand',
    description:
      'One of the leading production houses in Thailand, specialising in corporate films and television commercials (TVC).',
    longDescription:
      'We would like to introduce ourselves as one of the leading production houses in Thailand, specialising in corporate films and television commercials (TVC). We also provide line production facilities all over entire Thailand.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-purple-900/70 to-indigo-900/70',
    location: 'Bangkok, Thailand',
    address: 'Bangkok, Thailand',
    category: 'Entertainment',
    managingDirector: 'Vivek Bandi',
    establishedYear: '2004',
    email: 'vivek0305@gmail.com',
    contactNumber: '+66811770305',
    lineId: 'j2filming',
    registrations: ['Thai Film Board', 'Ministry of Tourism Thailand'],
    services: [
      'Locations and permissions',
      'Art and set construction',
      'Studios',
      'Vehicles for shooting and production',
      'Prosthetics and animatronics',
      'Under water and Marine facilities',
      'Animals',
      'Stunt and rigging',
      'Equipment (in-house jimmy jib and basic equipment)',
      'Accommodations across Thailand',
      'Catering with Indian and Thai cuisine',
    ],
    gallery: [
      {
        url: 'https://images.pexels.com/photos/2510428/pexels-photo-2510428.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Professional camera setup',
        caption: 'High-end cinema camera equipment',
      },
      {
        url: 'https://images.pexels.com/photos/3062545/pexels-photo-3062545.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Film set lighting',
        caption: 'Professional lighting for studio shoots',
      },
      {
        url: 'https://images.pexels.com/photos/2873486/pexels-photo-2873486.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Director monitor',
        caption: 'On-set monitoring and direction',
      },
      {
        url: 'https://images.pexels.com/photos/1117132/pexels-photo-1117132.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Film crew working',
        caption: 'Experienced crew managing production',
      },
    ],
    movies: [
      'MTV Roadies 5.5',
      'KISS (Kanada)',
      'Damaka (Malayam)',
      'Naa girlfriend baaga rich (Telugu)',
      'Raja babu (Telugu)',
      'Aha na Palli Anta (Telugu)',
      'Proper Potala (Punjabi)',
      'United six (Hindi)',
      'Action 3D (Telugu)',
      'Lokam ma kothaga (Telugu)',
      'Bramalokam to yamalokam yai bulokam (Telugu)',
      'Tajmahal (Telugu)',
      'Warw wha (Telugu)',
      '18 20 love story (Telugu)',
      'Chocolate (Malayam)',
      'Vinodam 100% (Telugu)',
      'Power (Marathi)',
      '35% pass (Marathi)',
      'Preeyatama (Marathi)',
      'Chiakaniya ammie chukalanti abbai (Telugu)',
      'Jaggu bhai (Tamil)',
      'Rasgulla (Kannada)',
      'Lifestyle mupallani shiva (Telugu)',
      'Poonami nagu (Telugu)',
      'Puthagam (Tamil)',
      'Punaminagu (Telugu)',
      'Maina pyar Kiya (Telugu)',
      'Maha mudhuru (Vijay Tamil, Telugu)',
      'Kushi Kushi yaghi (Kannada)',
      'Jalwa (Hindi)',
      'Boom boom (Telugu)',
      'Mitti thi kushboo (Ayushmaan Khurana Hindi album)',
      'Rainbow (Telugu)',
      'Awara (Tamil) movie kartik',
      'Ek Hindustani (Hindi)',
      'Boom boom (Telugu)',
      'Bibavastam Telugu song',
      'Mango (Tamil)',
      'Aligiya tamil madan (Tamil)',
      'Ma aur Charles (Hindi)',
      'Bhaji rao mastani (Hindi)',
      'Mosagralu ki mosagadu (Telugu)',
      'Pulimurugan (Malayalam)',
      'Chuttalabbayi (Telugu)',
      'Chalaki (Telugu)',
      'Rock (Kannada)',
      'Boxer (Kannada/Telugu)',
      'Missing boy (Kannada)',
      'Love by chance (Web series)',
      'Happy new year (Kannada)',
      'Ho ja Zara Matlabi (Hindi)',
      'Manyam puli (Telugu)',
      'Pspk 25 (Telugu)',
      'Warrant (The Mission) Kannada',
      'Uppi rupee (Kannada)',
      'Home Minister (Kannada)',
      'Meesam (Telugu)',
      'Mersal (Tamil)',
      'Petarap (Tamil)',
      'Mr. Zoo Keeper (Malayam)',
      'Zee 5 web series',
      'Samaradu (Telugu)',
    ],
    tvcs: [
      'Nandu Lungi',
      'Panasonic Battery',
      'Velvet shampoo',
      'Tata indicom',
      'AXA life insurance',
      'Reliance life Insurance',
      'Steak hair colour',
      'MRF Tyre',
      'Sunsilk shampoo',
      'Chic shampoo',
      'Samsung mobile S5',
      'Mischief suits',
      'Reliance mutual funds',
      'XMAN face wash',
      'Renova',
      'VGuard home appliances',
      'Nyle shampoo',
      'Care fairness cream',
      'Samsung mobile galaxy mini',
      'Reliance insurance',
      'RR pan masala',
      'Betasine cream',
      'Twisto chocolate (Pakistan)',
      'Ecliars chocolate (Pakistan)',
      'Otto undergarments',
      'Vivo mobile',
    ],
  },
  {
    slug: 'malgudi-filmy-restaurant',
    name: 'Malgudi Filmy Restaurant',
    description:
      'A new and exciting dining experience bringing the magic of Indian cinema to life through authentic cuisine and vibrant ambiance. Specializing in North and South Indian delicacies with a unique cinematic twist.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/958545/pexels-photo-958545.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-red-600/70 to-yellow-500/70',
    location: 'Pattaya',
    address:
      '78/89, Moo-9, Naklua Sub District, Bang Lamung District, Chonburi Province, Pattaya',
    hours: '11:00 AM - 11:00 PM (Daily)',
    contact: 'Malgudi Filmy Restaurant',
    contactNumber: '+66 XX XXX XXXX',
    capacity: '900',
    category: 'Indian Restaurant',
    features: [
      'North & South Indian Cuisine',
      'Cinematic Dining Experience',
      'Group Dining',
      'Family Friendly',
      'Live Entertainment',
    ],
    gallery: [
      {
        url: 'https://images.pexels.com/photos/941861/pexels-photo-941861.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Restaurant interior',
        caption: 'Cinematic dining ambiance',
      },
      {
        url: 'https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Dining table setup',
        caption: 'Elegant table settings',
      },
      {
        url: 'https://images.pexels.com/photos/67468/pexels-photo-67468.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Indian cuisine',
        caption: 'Authentic flavors served fresh',
      },
      {
        url: 'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Chef preparing food',
        caption: 'Expert chefs at work',
      },
    ],
    menuItems: [
      {
        name: 'Butter Chicken',
        description: 'Tender chicken in a rich, creamy tomato sauce',
        price: '฿350',
        image:
          'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Paneer Tikka',
        description: 'Grilled cottage cheese marinated in spices',
        price: '฿280',
        image:
          'https://images.pexels.com/photos/3928854/pexels-photo-3928854.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Garlic Naan',
        description: 'Freshly baked flatbread with garlic and butter',
        price: '฿80',
        image:
          'https://images.pexels.com/photos/4491395/pexels-photo-4491395.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Mango Lassi',
        description: 'Refreshing yogurt drink with sweet mango',
        price: '฿120',
        image:
          'https://images.pexels.com/photos/5946633/pexels-photo-5946633.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
    ],
    reviews: [
      {
        author: 'Rajesh K.',
        rating: 5,
        text: 'Amazing food and the Bollywood theme makes it a unique experience. Must visit in Pattaya!',
        date: '2025-01-10',
      },
    ],
  },
  {
    slug: 'haldi',
    name: 'Haldi',
    description:
      'Authentic vegetarian Indian cuisine specializing in Jain food. Our restaurant offers a pure vegetarian menu with a focus on traditional flavors and healthy dining options.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-amber-500/70 to-amber-700/70',
    location: 'Bangkok',
    address:
      '625, Phetchaburi 31 Road, OPP Eastin Hotel (Soi Charurat) Makkasan, Ratchathewi, Bangkok 10400',
    hours: '11:00 AM - 10:30 PM (Daily)',
    contact: 'Haldi Restaurant',
    contactNumber: '+66 96 798 7660',
    email: 'haldibkk@gmail.com',
    capacity: '150',
    category: 'Vegetarian Restaurant',
    features: [
      'Pure Vegetarian',
      'Specialized in Jain Food',
      'Group Dining',
      'Takeaway Available',
      'Family Friendly',
    ],
    gallery: [
      {
        url: 'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Vegetarian thali',
        caption: 'Traditional vegetarian thali',
      },
      {
        url: 'https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Healthy food spread',
        caption: 'Fresh and healthy vegetarian options',
      },
      {
        url: 'https://images.pexels.com/photos/1099680/pexels-photo-1099680.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Spices and ingredients',
        caption: 'Authentic spices used in our kitchen',
      },
      {
        url: 'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Restaurant ambiance',
        caption: 'Peaceful dining environment',
      },
    ],
    menuItems: [
      {
        name: 'Jain Thali',
        description:
          'Complete meal with dal, vegetables, roti, and rice (No onion/garlic)',
        price: '฿250',
        image:
          'https://images.pexels.com/photos/5410400/pexels-photo-5410400.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Palak Paneer',
        description: 'Cottage cheese cubes in spinach gravy',
        price: '฿220',
        image:
          'https://images.pexels.com/photos/3928854/pexels-photo-3928854.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Vegetable Biryani',
        description: 'Aromatic rice cooked with mixed vegetables',
        price: '฿200',
        image:
          'https://images.pexels.com/photos/12737656/pexels-photo-12737656.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Masala Chai',
        description: 'Traditional Indian spiced tea',
        price: '฿60',
        image:
          'https://images.pexels.com/photos/5946668/pexels-photo-5946668.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
    ],
    reviews: [
      {
        author: 'Priya S.',
        rating: 5,
        text: 'The best vegetarian Indian food in Bangkok! Their Jain thali is absolutely delicious.',
        date: '2025-06-15',
      },
      {
        author: 'Rahul M.',
        rating: 4,
        text: 'Great place for authentic vegetarian dishes. The service is excellent and the food quality is top-notch.',
        date: '2025-05-22',
      },
    ],
  },
  {
    slug: 'indian-express-restaurant',
    name: 'Indian Express Restaurant',
    description:
      "Indian Express Restaurant was established on 1st March 2022 by Mr. Bandi Vivek Wardhan. It provides exceptional dining experience by offering authentic Indian cuisine made with high quality ingredients and traditional cooking methods. We bring India's vibrant flavors to Bangkok ensuring that every dish is packed with bold spices and rich aroma you love. We have highly qualified, experienced chefs who make all the regional dishes of India.",
    status: 'active',
    image:
      'https://images.pexels.com/photos/1307698/pexels-photo-1307698.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-red-900/70 to-rose-800/70',
    location: 'Bangkok, Thailand',
    address:
      '70/55-56 Phetchaburi Road soi 31 Alley, Makassan, Ratchathani, Bangkok-10400',
    contactPerson: 'Mr. Rathnakar',
    contactNumber: '+66 972970305 / +66 990899003',
    email: 'indianexpressbkk@gmail.com',
    website: 'www.indianexpressthai.com',
    capacity: '120',
    category: 'Fine Dining',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
    ],
    gallery: [
      {
        url: 'https://images.pexels.com/photos/958545/pexels-photo-958545.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Fine dining setup',
        caption: 'Elegant fine dining atmosphere',
      },
      {
        url: 'https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Restaurant interior',
        caption: 'Spacious and comfortable seating',
      },
      {
        url: 'https://images.pexels.com/photos/67468/pexels-photo-67468.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Indian curry dish',
        caption: 'Rich and flavorful curries',
      },
      {
        url: 'https://images.pexels.com/photos/260922/pexels-photo-260922.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Bar area',
        caption: 'Full service bar available',
      },
    ],
    menuItems: [
      {
        name: 'Chicken Tikka Masala',
        description: 'Grilled chicken chunks in spicy curry sauce',
        price: '฿320',
        image:
          'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Lamb Rogan Josh',
        description: 'Aromatic lamb dish of Persian origin',
        price: '฿380',
        image:
          'https://images.pexels.com/photos/5410400/pexels-photo-5410400.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Hyderabadi Biryani',
        description: 'Spicy rice dish with marinated meat',
        price: '฿300',
        image:
          'https://images.pexels.com/photos/12737656/pexels-photo-12737656.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Gulab Jamun',
        description: 'Sweet milk solids soaked in sugar syrup',
        price: '฿100',
        image:
          'https://images.pexels.com/photos/5946633/pexels-photo-5946633.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
    ],
  },
  {
    slug: 'india-greens',
    name: 'India Greens',
    description:
      'India Greens is a restaurant that serves a multi-course menu designed to create a journey for breakfast, lunch, and dinner. The menu price is just designed that anyone can afford. We have specific chefs for North and South Indian dishes. We serve fresh and authentic food which is prepared by professional chefs who worked in 4 and 5-star hotels previously. We are available 24x7 for service.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/2679501/pexels-photo-2679501.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-emerald-900/70 to-green-800/70',
    location: 'Bangkok, Thailand',
    address:
      '70/52 Phetchaburi Road 31 (Soi Jarurat), Makkasan, Ratchathani, Bangkok-10400',
    contactPerson: 'Mr. Vineet Yadav',
    contactNumber: '+66 886674225',
    email: 'indiagreeensbkk@gmail.com',
    capacity: '44',
    category: 'Casual Dining',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
    ],
    gallery: [
      {
        url: 'https://images.pexels.com/photos/2679501/pexels-photo-2679501.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Fresh green salad',
        caption: 'Fresh ingredients daily',
      },
      {
        url: 'https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Buffet spread',
        caption: 'Extensive buffet selection',
      },
      {
        url: 'https://images.pexels.com/photos/1126728/pexels-photo-1126728.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Casual dining area',
        caption: 'Relaxed casual dining space',
      },
      {
        url: 'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Open kitchen',
        caption: 'View of our open kitchen',
      },
    ],
    reviews: [
      {
        author: 'Palani Govind',
        rating: 5,
        text: 'Tasty Food. Vegetarian options: Better to have south Indian meal',
        date: '1 week ago',
      },
      {
        author: 'Aleisha Nunna',
        rating: 5,
        text: 'good food, great ambience and great staff, must visit, one of the best Indian restaurants in Bangkok',
        date: '2 months ago',
      },
    ],
  },
  {
    slug: 'malgudi-indian-restaurant',
    name: 'Malgudi Indian Restaurant',
    description:
      'Malgudi is an Indian Restaurant offering North and South Indian delicacies. Management and chefs are with 30+ years of magical experience in the food industry, we promise a quality and delicious rollercoaster ride of wide range of varieties.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/2159065/pexels-photo-2159065.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-amber-900/70 to-orange-800/70',
    location: 'Bangkok, Thailand',
    address:
      '625, Phetchaburi 31 Road, Opp Eastin Hotel (Soi Charurat) Makassan, Ratchathewi',
    contactPerson: 'Mr. Yuvraj Damir',
    contactNumber: '+66 652329517',
    email: 'malgudibkk@gmail.com',
    capacity: '100',
    category: 'Fine Dining',
    hours: '10:00 AM - 12:00 AM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
    ],
    gallery: [
      {
        url: 'https://images.pexels.com/photos/2159065/pexels-photo-2159065.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'South Indian Dosa',
        caption: 'Crispy Dosas served hot',
      },
      {
        url: 'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Traditional Thali',
        caption: 'Complete South Indian meal',
      },
      {
        url: 'https://images.pexels.com/photos/941861/pexels-photo-941861.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Restaurant decor',
        caption: 'Traditional Indian decor',
      },
      {
        url: 'https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Family dining',
        caption: 'Perfect for family gatherings',
      },
    ],
    menuItems: [
      {
        name: 'Masala Dosa',
        description: 'Crispy crepe filled with spiced potato',
        price: '฿180',
        image:
          'https://images.pexels.com/photos/5560763/pexels-photo-5560763.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Idli Sambar',
        description: 'Steamed rice cakes with lentil soup',
        price: '฿150',
        image:
          'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Chicken Chettinad',
        description: 'Spicy chicken curry from Chettinad region',
        price: '฿320',
        image:
          'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Filter Coffee',
        description: 'Traditional South Indian coffee',
        price: '฿80',
        image:
          'https://images.pexels.com/photos/5946668/pexels-photo-5946668.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
    ],
  },
  {
    slug: 'cholas-indian-restaurant',
    name: 'Cholas Indian Restaurant',
    description:
      'The Cholas (8th-12th century AD) are remembered as one of the largest ruling dynasties in the southern regions of India. Cholasbkk is a fine dining establishment offering a fusion of Indian and Thai cuisines. The Restaurant provides halal options and South Indian specialties. It offers both dine-in and delivery services. Cholasbkk features a bar and serves alcohol. The venue is family-friendly, offering high chairs and highlighting the authenticity of the Indian flavors while emphasizing the fresh, high-quality ingredients, and mentioning the unique dining experience offered in an Indian setting.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/941861/pexels-photo-941861.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-red-900/70 to-rose-800/70',
    location: 'Bangkok, Thailand',
    address:
      '629, Phetchburi 31 Road, Opp Eastin Hotel (Soi Charurat) Makassan, Ratchathewi Bangkok 10400',
    contactPerson: 'Sagar Gambhir',
    contactNumber: '+66 613951269',
    email: 'cholasbkk@gmail.com',
    instagram: 'cholasbkk',
    capacity: '150',
    category: 'Fine Dining',
    hours: '10:00 AM - 12:00 AM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
    ],
    gallery: [
      {
        url: 'https://images.pexels.com/photos/941861/pexels-photo-941861.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Fusion dining',
        caption: 'Indian and Thai fusion dining',
      },
      {
        url: 'https://images.pexels.com/photos/67468/pexels-photo-67468.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Plated dish',
        caption: 'Exquisite plating and presentation',
      },
      {
        url: 'https://images.pexels.com/photos/260922/pexels-photo-260922.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Bar lounge',
        caption: 'Relaxing bar and lounge area',
      },
      {
        url: 'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?auto=compress&cs=tinysrgb&w=800',
        alt: 'Private dining',
        caption: 'Private dining options available',
      },
    ],
    menuItems: [
      {
        name: 'Fish Curry',
        description: 'Traditional coastal fish curry',
        price: '฿350',
        image:
          'https://images.pexels.com/photos/262959/pexels-photo-262959.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Prawn Masala',
        description: 'Spicy prawn stir-fry with spices',
        price: '฿380',
        image:
          'https://images.pexels.com/photos/699953/pexels-photo-699953.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Thai Green Curry',
        description: 'Authentic Thai green curry with chicken',
        price: '฿280',
        image:
          'https://images.pexels.com/photos/67468/pexels-photo-67468.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Pad Thai',
        description: 'Classic Thai stir-fried noodles',
        price: '฿220',
        image:
          'https://images.pexels.com/photos/699953/pexels-photo-699953.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
    ],
  },
  {
    slug: 'royal-bengal-tigers',
    name: 'Royal Bengal Tigers',
    description:
      'Royal Bengal Tiger restaurant is a very big restaurant which can accommodate 380 people at a time. Breakfast and lunch are very famous with Tiger. We have 3 tigers. You can eat the food with tigers. You will get many varieties of Indian food like North Indian & South Indian. We have particular chef for North and South dishes. The good thing is that we serve fresh and authentic food which is prepared by professional chefs who have degrees and experience from 4 and 5-star hotels. Our staff is very kind. They take care of guests like home.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/1581384/pexels-photo-1581384.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-yellow-900/70 to-amber-800/70',
    location: 'Chonburi, Thailand',
    address: '341 moo 3, Nhongkham SriRacha, Chonburi 20110',
    contactPerson: 'Mr Bhanu Pyde/Akash Tripathi',
    contactNumber: '+66 92 275 1269 / +66 61 394 1369',
    email: 'rbtsriracha@gmail.com / bookingrbtsriracha@gmail.com',
    facebook: 'rbtsriracha',
    instagram: 'rbtsriracha',
    capacity: '380',
    category: 'Specialty Restaurant',
    hours: '6:30 AM - 7:00 PM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
      'Pan Asian Cuisine',
    ],
    menuItems: [
      {
        name: 'Tandoori Platter',
        description: 'Assortment of grilled meats and kebabs',
        price: '฿550',
        image:
          'https://images.pexels.com/photos/262959/pexels-photo-262959.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Mutton Biryani',
        description: 'Fragrant rice cooked with tender mutton',
        price: '฿380',
        image:
          'https://images.pexels.com/photos/12737656/pexels-photo-12737656.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Pan Asian Stir Fry',
        description: 'Mixed vegetables in savory asian sauce',
        price: '฿250',
        image:
          'https://images.pexels.com/photos/699953/pexels-photo-699953.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Sizzling Brownie',
        description: 'Hot brownie served with vanilla ice cream',
        price: '฿180',
        image:
          'https://images.pexels.com/photos/45202/brownie-dessert-cake-sweet-45202.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
    ],
  },
  {
    slug: 'malgudi-floating-market-pattaya',
    name: 'Malgudi Indian Restaurant (Floating Market, Pattaya)',
    description:
      "Malgudi is an Indian/Thai restaurant offering North and South food delicacies. Located in the vibrant Pattaya Floating Market, our restaurant features elegant interiors with custom lighting, traditional Indian décor, and a spacious dining area. We offer both à la carte and buffet services, with a focus on authentic North and South Indian cuisine. The restaurant's ambiance combines modern luxury with traditional Indian elements, featuring custom wooden furniture, decorative runners, and artistic wall murals that pay homage to Indian culture.",
    status: 'active',
    image:
      'https://images.pexels.com/photos/2347311/pexels-photo-2347311.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-amber-900/70 to-yellow-800/70',
    location: 'Pattaya, Thailand',
    address:
      'Floating Market Pattaya c-32, 451 12 Sukhumvit Road, Muang Pattaya, Bang Lamung District, Chon Buri 20150',
    contactPerson: 'Mr. Yuvraj / Mr. Shan',
    contactNumber: '+66 652329517 / +66 614071296',
    email: 'malgudifloatingmarket@gmail.com',
    capacity: '250',
    category: 'Specialty Restaurant',
    hours: '8:00 AM - 7:00 PM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
      'Pan Asian Cuisine',
    ],
    features: [
      'Halal Certified',
      'Buffet Service',
      'Private Dining Areas',
      'Custom Lighting',
      'Traditional Décor',
      'Family Friendly',
      'Group Seating Available',
      'Air Conditioned',
    ],
  },
  {
    slug: 'chennai-express',
    name: 'Chennai Express',
    description:
      'We are the authentic Indian restaurant serving both non-vegetarian and vegetarian food. So welcome to the flavor center where eating is thrilling, for us no ordinary meals allowed. We serve Pan Asian and Pan Indian food.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/2474658/pexels-photo-2474658.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-teal-900/70 to-cyan-800/70',
    location: 'Bangkok, Thailand',
    address:
      '120/20 soi-3 Rachaprarop Road, Opp. Indra Market, Pratunam, Ratchathewi, Bangkok, 10400, Thailand',
    contactPerson: 'Nitesh Rana',
    contactNumber: '+66 654142181',
    email: 'chennaiexpressbkk@gmail.com',
    instagram: 'chennaiexpress4477',
    facebook: 'chennai express',
    capacity: '50',
    category: 'Casual Dining',
    hours: '10:00 AM - 12:00 AM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
    ],
  },
  {
    slug: 'saffron-indian-continental-lounge-bar',
    name: 'Saffron Indian-Continental-Lounge-Bar',
    description:
      'Saffron Restaurant provides Multicuisine dishes. We are providing authentic taste of Indian delicacy for breakfast, lunch and dinner. Indian flavors meet modern culinary artistry. We invite people to experience a vibrant dining journey with our freshly-prepared dishes, featuring Indian sourced ingredients and a menu designed to tantalize your taste buds. We have the best chefs of the industry with experience of more than 20 years in 5-to-7-star hotels. We are open 24 hours. The ambience of the restaurant is cozy and charming.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/696218/pexels-photo-696218.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-orange-900/70 to-red-800/70',
    location: 'Bangkok, Thailand',
    address:
      '22/22 Ground Floor, Citadines Hotels, Soi 11, Sukhumvit Road, Bangkok-10110',
    contactPerson: 'Akshay Sanas',
    contactNumber: '+66 992288972, WhatsApp only +66 610201269',
    email: 'saffronsukhumvit@gmail.com',
    facebook: 'saffron_bkk',
    capacity: '100',
    category: 'Lounge & Bar',
    hours: 'Open 24 Hours',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
      'Pan Asian Cuisine',
    ],
    menuItems: [
      {
        name: 'Cocktail Selection',
        description: 'Signature cocktails crafted by expert mixologists',
        price: '฿280',
        image:
          'https://images.pexels.com/photos/602794/pexels-photo-602794.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Tapas Platter',
        description: 'Selection of small bites perfect for sharing',
        price: '฿450',
        image:
          'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Grilled Salmon',
        description: 'Fresh salmon fillet with seasonal vegetables',
        price: '฿550',
        image:
          'https://images.pexels.com/photos/262959/pexels-photo-262959.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
      {
        name: 'Pasta Carbonara',
        description: 'Classic Italian pasta with creamy sauce',
        price: '฿320',
        image:
          'https://images.pexels.com/photos/1279330/pexels-photo-1279330.jpeg?auto=compress&cs=tinysrgb&w=800',
      },
    ],
  },
  {
    slug: 'malgudi-the-village-food',
    name: 'Malgudi the Village Food (Indra Square)',
    description:
      'The name is inspired by the 1980s classic television show "Malgudi Days". As India\'s fastest growing South Indian cuisine, Malgudi has a place in the heart and now Thailand as well.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/2673353/pexels-photo-2673353.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-purple-900/70 to-fuchsia-800/70',
    location: 'Bangkok, Thailand',
    address:
      'No. 120/28 soi Ratchaprarop 3, Thanon Phaya Thai, Ratchathewi, Bangkok 10400 Opp Indra Square',
    contactPerson: 'Yogi Gambhir',
    contactNumber: '+66 61 394 1296',
    email: 'malgudiindra@gmail.com',
    capacity: '90',
    category: 'Casual Dining',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
    ],
  },
  {
    slug: 'salaam-namaste',
    name: 'Salaam Namaste',
    description:
      'Welcome to Salaam Namaste, a vibrant Indian restaurant nestled in the heart of downtown. We pride ourselves on serving authentic, flavorful dishes prepared with the freshest spices and traditional cooking methods, creating an immersive dining experience that transports you straight to the bustling streets of India. Our interiors are the best in Bangkok - you will not see such an interior anywhere else in Bangkok because it has memories of the village.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-blue-900/70 to-indigo-800/70',
    location: 'Opp:Bangkok Palace Hotel, Bangkok, Thailand',
    address:
      '1091/296/beside Ecotel Hotel Phetchaburi Road, Makkasan, Ratchathewi, Bangkok 10400',
    contactPerson: 'Mr. Mahesh Pandey',
    contactNumber: '+66 632251269',
    email: 'salaamnamastethi@gmail.com',
    facebook: 'salamnamastethai',
    capacity: '60',
    category: 'Fine Dining',
    hours: '10:00 AM - 1:00 AM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
    ],
  },
  {
    slug: 'iris-pattaya',
    name: 'Iris Pattaya',
    description:
      'A beachfront restaurant and lounge offering a blend of Indian and international cuisine with stunning views of the Gulf of Thailand. Iris Pattaya provides a unique dining experience with its beautiful seaside setting, perfect for enjoying delicious meals while watching the sunset over the Gulf of Thailand.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/1268855/pexels-photo-1268855.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-sky-900/70 to-blue-800/70',
    location: 'Near First SPA, Pattaya, Thailand',
    address:
      '8161 Village no 6, North Pattaya Road, Near First SPA, Pattaya, Banglamung, Chon Buri 20150',
    contactPerson: 'Rathnakar G',
    contactNumber: '+66 61 394 1369',
    email: 'irishbvgroup@gmail.com',
    capacity: '120',
    category: 'Lounge & Bar',
    hours: '7:00 AM - 1:00 AM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
      'Pan Indian Cuisine',
    ],
  },
  {
    slug: 'fusion-pattaya',
    name: 'Fusion Pattaya',
    description:
      'A beachfront restaurant and lounge offering a blend of Indian and international cuisine with stunning views of the Gulf of Thailand. Fusion Pattaya provides a unique dining experience with its beautiful seaside setting, perfect for enjoying delicious meals while watching the sunset over the Gulf of Thailand.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/67468/pexels-photo-67468.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-sky-900/70 to-blue-800/70',
    location: 'Near Big Buddha, Pattaya, Thailand',
    address:
      'Tambol Nongprue, Kasetsin 5 Alley, Pattaya City, Amphoe Bang Lamung, Chon Buri 20150, Thailand',
    contactPerson: 'Atul Mohan',
    contactNumber: '+66 65 924 1269',
    email: 'fusionbvgroup@gmail.com',
    capacity: '120',
    category: 'Casual Dining',
    hours: '10:00 AM - 2:00 AM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
      'Pan Indian Cuisine',
      'Multi Cuisine',
      'Thai Cuisine',
      'Gala Dinner',
    ],
  },
  {
    slug: 'hyderabad-nawabs-restaurant',
    name: 'Hyderabad Nawabs Restaurant',
    description:
      'Hyderabad Nawabs Restaurant brings the royal flavors of Hyderabad to Pattaya with slow-cooked dum biryanis, succulent kebabs, and hearty curries served around the clock beside The Beverly Hotel.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/12737656/pexels-photo-12737656.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-rose-900/70 to-amber-700/70',
    location: 'Pattaya City, Thailand',
    address:
      '59, Beside The Beverly Hotel, 24-25 Moo 10, Pattaya City, Bang Lamung District, Chon Buri 20150',
    hours: 'Open 24 hours',
    contactPerson: 'Restaurant Team',
    contactNumber: '+66 65 414 2181',
    category: 'Casual Dining',
    services: [
      'À La Carte',
      'Hyderabadi Cuisine',
      'Family Dining',
      'Late-Night Dining',
      'Takeaway Available',
      'Catering',
    ],
    features: [
      'Open 24 Hours',
      'Signature Dum Biryani',
      'Family Friendly',
      'Near Pattaya Beach',
      'Vegetarian and Non-Vegetarian Options',
    ],
    reviews: [
      {
        author: 'Ravi Teja',
        rating: 5,
        text: 'Authentic Hyderabadi dum biryani with perfectly layered flavors—just like home.',
        date: '2025-02-18',
      },
      {
        author: 'Meera Iyer',
        rating: 4,
        text: 'Loved the kebabs and the fact that they are open 24/7, which saved our late-night cravings.',
        date: '2025-03-02',
      },
    ],
  },
  {
    slug: 'Malgudi-the-Village-Food-Palladium',
    name: 'Malgudi the Village Food (Palladium)',
    description:
      'Welcome to Malgudi the Village Food (Palladium), a vibrant Indian restaurant nestled in the heart of downtown. We pride ourselves on serving authentic, flavorful dishes prepared with the freshest spices and traditional cooking methods, creating an immersive dining experience that transports you straight to the bustling streets of India. Our interiors are the best in Bangkok - you will not see such an interior anywhere else in Bangkok because it has memories of the village.',
    status: 'active',
    image:
      'https://images.pexels.com/photos/2233729/pexels-photo-2233729.jpeg?auto=compress&cs=tinysrgb&w=800',
    gradient: 'bg-gradient-to-r from-blue-900/70 to-indigo-800/70',
    location: 'Shop No. 01 , 1st Floor , The Palladium World Shopping',
    address:
      'Shop No. 01 , 1st Floor , The Palladium World Shopping 555 Ratchaprarop Road , Makkasan, Ratchathewi, Bangkok Bangkok 10400',
    contactNumber: '0839488744',
    email: 'malgudibkk@gmail.com',
    category: 'Casual Dining',
    hours: '10:30 AM - 11:00 PM',
    services: [
      'Buffet',
      'À La Carte',
      'Indian Cuisine',
      'South Indian Cuisine',
      'North Indian Cuisine',
      'Pan Indian Cuisine',
    ],
  },
]

export function getBusinessBySlug(slug: string): Business | undefined {
  return businesses.find((b) => b.slug === slug)
}

export function getRelatedBusinesses(
  currentSlug: string,
  limit = 3,
): Business[] {
  const currentBusiness = businesses.find((b) => b.slug === currentSlug)
  if (!currentBusiness) return []
  return businesses
    .filter(
      (b) => b.slug !== currentSlug && b.category === currentBusiness.category,
    )
    .slice(0, limit)
}
